import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import dayjs from 'dayjs';
import { FieldUsageSelector } from '@ui/tags/FieldUsageSelector';
import { InlineMetadata } from '@periscopes/general/metadata';
import React from 'react';
import { When } from 'react-if';

import { ComplianceCategorySelector, DataSensitivitySelector } from '@ui/tags';
import { GoToDictionaryButton, InformationSection, IngestedBySection, PopulatedBySection } from '@periscopes/general';
import { PeriscopeSfFieldMetadata, SonarObjectType } from '@sonar-software/sonar-ts-types';
import { SalesforceDescription, SalesforceHelpText, SonarText } from '@ui/text';
import { usePeriscopeMetadata, useSonarObjectReference } from '@hooks';

export interface FieldInformationProps {
	sonarObjectId: number;
}

export const FieldInformation: React.FC<FieldInformationProps> = ({ sonarObjectId }) => {
	const { parentSonarObjectId } = useSonarObjectReference(sonarObjectId);
	const { metadata } = usePeriscopeMetadata<PeriscopeSfFieldMetadata>(sonarObjectId, SonarObjectType.SalesforceField);

	return (
		<InformationSection
			headerAction={ <GoToDictionaryButton sonarObjectId={ parentSonarObjectId } /> }
			sonarObjectId={ sonarObjectId }>
			<SalesforceDescription sonarObjectId={ sonarObjectId } />
			<SalesforceHelpText sonarObjectId={ sonarObjectId } />
			<InlineMetadata
				headerSpaceAlign='start'
				label={ COPY_SPECIFIC.COMPLIANCE_CATEGORY }>
				<ComplianceCategorySelector
					direction='horizontal'
					sonarObjectId={ sonarObjectId } />
			</InlineMetadata>
			<InlineMetadata label={ COPY_SPECIFIC.DATA_SENSITIVITY }>
				<DataSensitivitySelector sonarObjectId={ sonarObjectId } />
			</InlineMetadata>
			<InlineMetadata label={ COPY_SPECIFIC.FIELD_USAGE }>
				<FieldUsageSelector sonarObjectId={ sonarObjectId } />
			</InlineMetadata>
			<IngestedBySection sonarObjectId={ sonarObjectId } />
			<PopulatedBySection sonarObjectId={ sonarObjectId } />
			<When condition={ Boolean(metadata?.populationPercentageLastAnalyzed) }>
				<InlineMetadata label={ COPY_SPECIFIC.POPULATION_PERCENT_LAST_ANALYZED }>
					<SonarText>{ dayjs(metadata?.populationPercentageLastAnalyzed).format('L') }</SonarText>
				</InlineMetadata>
			</When>
		</InformationSection>
	);
};
